export default __webpack_public_path__ + "static/media/no-see-group-icon.cb10a0d8.svg";